import RequestAdapter from '../adapters/RequestAdapter';
import { API_V3_PATH_BASE } from '../constants';
import { ENDPOINTS } from '../enums/endpoints';

const getSubscriptionDetails = () => {
  const requestConfig = {
    url: `${API_V3_PATH_BASE}${ENDPOINTS.SUBSCRIPTION.DETAILS}`,
    method: 'GET',
  };

  return RequestAdapter.request(requestConfig);
};

export const SubscriptionService = {
  getSubscriptionDetails,
};
